import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MemberNavigationService {

    static displayModeParamName = 'mode';
    static displaySubModeParamName = 'submode';
}
